// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wSNMi2wH114r2rY4qWoW {
  display: flex;
  flex-direction: column;
}

.Vhgg9D0uVmjGZoD3X98q {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-5);
}

.Vhgg9D0uVmjGZoD3X98q + .Vhgg9D0uVmjGZoD3X98q {
  margin-top: var(--sl-space-6);
  padding-top: var(--sl-space-6);
  border-top: var(--sl-border-base);
}

.CMzWZQMWF6Yo7hmsToon {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--sl-space-2) var(--sl-space-4);
}

.T3qc4B4eXGkt_VUbg_vA {
  display: flex;
  flex: 1 1 260px;
  flex-direction: column;
  gap: var(--sl-space-1);
  min-width: 0;
}

.rfCywDbeT9oBPOYKsZGC {
  min-width: 0;
  overflow-wrap: anywhere;
}

.Q0iv0fwEXb5TzMfg3s9g {
  flex-shrink: 0;
}

[data-sl-button].Q0iv0fwEXb5TzMfg3s9g[aria-disabled='true'],
[data-sl-button].Q0iv0fwEXb5TzMfg3s9g[aria-disabled='true']:hover {
  color: var(--sl-fg-base-disabled);
  background: none;
  cursor: not-allowed;
}

.HTdN8JAXP_BgYimEkj9w {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-4);
  margin-top: var(--sl-space-6);
  padding-top: var(--sl-space-6);
  border-top: var(--sl-border-base);
}

.SniT0sQUcLI8UWtajW6v {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sl-space-1);
  max-width: 520px;
  margin: 0 auto;
  padding: var(--sl-space-8) var(--sl-space-4) var(--sl-space-4);
  text-align: center;
}

.JXDbUgWxBQSCmDSjTwAu {
  width: 100%;
}

.o8ejucTsL6GLCWL0ep4P {
  max-width: 450px;
  min-width: 0;
  padding: var(--sl-space-4);
  border: var(--sl-border-base);
  border-radius: var(--sl-radius-2);
  background: var(--sl-bg-base-soft);
}

.o8ejucTsL6GLCWL0ep4P > *:last-child {
  margin-top: var(--sl-space-1);
}

.DyiKurcGWFs362auTyxd {
  margin: 0;
  min-width: 0;
}

.DyiKurcGWFs362auTyxd dd {
  margin: var(--sl-space-1) 0 0;
  overflow-wrap: anywhere;
}

.DupK9vrgjCXvfsjV9bEz {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-1);
}

.nP4KV6x2uj6VmOsW8EyU {
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-body-font);
}

@media (max-width: 992px) {
  .JXDbUgWxBQSCmDSjTwAu {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .iiCxpKKbIw0Vg6OSJnlM [class*='sl-grid'],
  .iiCxpKKbIw0Vg6OSJnlM > div {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

@media (max-width: 576px) {
  .JXDbUgWxBQSCmDSjTwAu {
    grid-template-columns: 1fr !important;
  }

  .iiCxpKKbIw0Vg6OSJnlM [class*='sl-grid'],
  .iiCxpKKbIw0Vg6OSJnlM > div {
    grid-template-columns: 1fr !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/CampaignInsertionOrderPanel/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,8DAA8D;EAC9D,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE;IACE,2DAA2D;EAC7D;;EAEA;;IAEE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;;IAEE,qCAAqC;EACvC;AACF","sourcesContent":[".list {\n  display: flex;\n  flex-direction: column;\n}\n\n.summary {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-5);\n}\n\n.summary + .summary {\n  margin-top: var(--sl-space-6);\n  padding-top: var(--sl-space-6);\n  border-top: var(--sl-border-base);\n}\n\n.headerRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--sl-space-2) var(--sl-space-4);\n}\n\n.header {\n  display: flex;\n  flex: 1 1 260px;\n  flex-direction: column;\n  gap: var(--sl-space-1);\n  min-width: 0;\n}\n\n.name {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.unlink {\n  flex-shrink: 0;\n}\n\n[data-sl-button].unlink[aria-disabled='true'],\n[data-sl-button].unlink[aria-disabled='true']:hover {\n  color: var(--sl-fg-base-disabled);\n  background: none;\n  cursor: not-allowed;\n}\n\n.linkBlock {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-4);\n  margin-top: var(--sl-space-6);\n  padding-top: var(--sl-space-6);\n  border-top: var(--sl-border-base);\n}\n\n.empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--sl-space-1);\n  max-width: 520px;\n  margin: 0 auto;\n  padding: var(--sl-space-8) var(--sl-space-4) var(--sl-space-4);\n  text-align: center;\n}\n\n.metrics {\n  width: 100%;\n}\n\n.metric {\n  max-width: 450px;\n  min-width: 0;\n  padding: var(--sl-space-4);\n  border: var(--sl-border-base);\n  border-radius: var(--sl-radius-2);\n  background: var(--sl-bg-base-soft);\n}\n\n.metric > *:last-child {\n  margin-top: var(--sl-space-1);\n}\n\n.settingItem {\n  margin: 0;\n  min-width: 0;\n}\n\n.settingItem dd {\n  margin: var(--sl-space-1) 0 0;\n  overflow-wrap: anywhere;\n}\n\n.seller {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-1);\n}\n\n.sellerEmail {\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-body-font);\n}\n\n@media (max-width: 992px) {\n  .metrics {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  }\n\n  .settings :global([class*='sl-grid']),\n  .settings > div {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .metrics {\n    grid-template-columns: 1fr !important;\n  }\n\n  .settings :global([class*='sl-grid']),\n  .settings > div {\n    grid-template-columns: 1fr !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `wSNMi2wH114r2rY4qWoW`,
	"summary": `Vhgg9D0uVmjGZoD3X98q`,
	"headerRow": `CMzWZQMWF6Yo7hmsToon`,
	"header": `T3qc4B4eXGkt_VUbg_vA`,
	"name": `rfCywDbeT9oBPOYKsZGC`,
	"unlink": `Q0iv0fwEXb5TzMfg3s9g`,
	"linkBlock": `HTdN8JAXP_BgYimEkj9w`,
	"empty": `SniT0sQUcLI8UWtajW6v`,
	"metrics": `JXDbUgWxBQSCmDSjTwAu`,
	"metric": `o8ejucTsL6GLCWL0ep4P`,
	"settingItem": `DyiKurcGWFs362auTyxd`,
	"seller": `DupK9vrgjCXvfsjV9bEz`,
	"sellerEmail": `nP4KV6x2uj6VmOsW8EyU`,
	"settings": `iiCxpKKbIw0Vg6OSJnlM`
};
export default ___CSS_LOADER_EXPORT___;
